// TODO(architecture): Replace this hardcoded shopper delivery destination with a
// delivery destination whitelist (allowed country + city pairs) so destinations
// can be configured rather than compiled into the cart Delivery Details step.
export const HARDCODED_SHOPPER_DELIVERY_DESTINATION = {
  countryIataCode: 'JM',
  countryName: 'Jamaica',
  cityIataCode: 'KIN',
  cityName: 'Kingston'
} as const

export const HARDCODED_SHOPPER_DELIVERY_COUNTRY_OPTIONS = [
  {
    value: HARDCODED_SHOPPER_DELIVERY_DESTINATION.countryIataCode,
    label: HARDCODED_SHOPPER_DELIVERY_DESTINATION.countryName
  }
]

export const HARDCODED_SHOPPER_DELIVERY_CITY_OPTIONS = [
  {
    value: HARDCODED_SHOPPER_DELIVERY_DESTINATION.cityIataCode,
    label: HARDCODED_SHOPPER_DELIVERY_DESTINATION.cityName
  }
]
